import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ViajesService } from 'src/app/_services/viajes.service';

@Component({
  selector: 'app-modal-categoria-hotel',
  templateUrl: './modal-categoria-hotel.component.html',
  styleUrls: ['./modal-categoria-hotel.component.css']
})
export class ModalCategoriaHotelComponent implements OnInit {
  form: FormGroup;
  submitted = false;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private viajesService: ViajesService,
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      categoria: ['', Validators.required]
    }, { validators: this.rangoCategoria()});
  }

  rangoCategoria(){
    return (formGroup: FormGroup) => {
      const control = formGroup.controls['categoria'];
      if ( (control.value < '1' ||  control.value > '5') &&  control.value !== '') {
          control.setErrors({ rangoCategoria: true });
      }       
    }
  }
  get f() { return this.form.controls; }

  onSubmit(){
    this.submitted = true;
    //this.errorService = false;

    // stop here if form is invalid
    if (this.form.invalid) {
        return;
    }
    //pasar categoria la padre
    this.viajesService.changeCategoriaHotel(this.f.categoria.value);
    this.activeModal.dismiss('Cross click');
  }

  keypressValue(event){
    var k;
    k = event.charCode;
    return ((k >= 48 && k <= 57));
  }

}
